import { render, staticRenderFns } from "./EmployeeOnBoardingModule.vue?vue&type=template&id=736fd53e&scoped=true&"
import script from "./EmployeeOnBoardingModule.vue?vue&type=script&lang=js&"
export * from "./EmployeeOnBoardingModule.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeOnBoardingModule.vue?vue&type=style&index=0&id=736fd53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fd53e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
